import React, { useState } from "react";
import box from "../../assets/measurement_box.png";
import Slider from "react-rangeslider";
import "react-rangeslider/lib/index.css";
import styles from "./CourierMeasurement.module.css";

import { useDispatch } from "react-redux";
import {
  saveLength,
  saveHeigth,
  saveWidth,
} from "../../redux/actions/orderActions";

const CourierMeasurement = ({ history }) => {
  const dispatch = useDispatch();

  const [length, setLength] = useState(0);
  const [height, setHeight] = useState(0);
  const [width, setWidth] = useState(0);

  const handleLength = (value) => {
    setLength(value);
  };
  const handleWidth = (value) => {
    setWidth(value);
  };
  const handleHeight = (value) => {
    setHeight(value);
  };

  const saveLHWInfo = () => {
    dispatch(saveLength(length, history));
    dispatch(saveHeigth(height, history));
    dispatch(saveWidth(width, history));
  };

  return (
    <div className={styles.container}>
      <h1>Select Measurements</h1>
      <span className={styles.length}>
        <p>Height</p>
        <p>{height} cm</p>
      </span>
      <img src={box} alt="measurement_box" />
      <span className={styles.height}>
        <p>Length</p>
        <p>{length} cm</p>
      </span>
      <span className={styles.width}>
        <p>Width</p>
        <p>{width} cm</p>
      </span>
      <div className={styles.sliderContainer}>
        <div className={styles.heightContainer}>
          <p>Height</p>
          <Slider
            value={height}
            orientation="vertical"
            onChange={handleHeight}
            labels={{ 0: "9", 100: "1000 cm" }}
          />
        </div>
        <div className={styles.widthAndLengthContainer}>
          <p>Width</p>
          <Slider
            value={width}
            orientation="horizontal"
            onChange={handleWidth}
            labels={{ 0: "9", 100: "1000 cm" }}
          />
          <p>Length</p>
          <Slider
            value={length}
            orientation="horizontal"
            onChange={handleLength}
            labels={{ 0: "9", 100: "1000 cm" }}
          />
        </div>
      </div>
      <button onClick={saveLHWInfo}>Update</button>
    </div>
  );
};

export default CourierMeasurement;
